"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _SimpleRule = _interopRequireDefault(require("./SimpleRule"));
var _RuleGroup = _interopRequireDefault(require("./RuleGroup"));
var _loader = require("../loader");
var _helpers = require("./helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var RulesBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(RulesBuilder, _React$Component);
  var _super = _createSuper(RulesBuilder);
  function RulesBuilder(props) {
    var _this;
    _classCallCheck(this, RulesBuilder);
    _this = _super.call(this, props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        selectedElement: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onRuleChange", function (_ref, pathKeys, variableOperands) {
      var variable = _ref.variable,
        operator = _ref.operator,
        values = _ref.values,
        uid = _ref.uid;
      var rulesCopy = R.clone(_this.props.rules);
      var newRules;
      if (pathKeys.length > 0) {
        var parentGroup = _this.getRuleObjectToChange(rulesCopy, pathKeys);
        parentGroup.element.eligibilityRows.splice(parentGroup.position, 1, _objectSpread(_objectSpread({}, (0, _helpers.getSimpleRuleValues)(variable, operator, values, variableOperands)), {}, {
          uid: uid
        }));
        newRules = _objectSpread({}, rulesCopy);
      } else {
        newRules = _objectSpread(_objectSpread({}, (0, _helpers.getSimpleRuleValues)(variable, operator, values, variableOperands)), {}, {
          uid: uid
        });
      }
      _this.props.onChange(newRules, {
        rule: {
          variable: variable,
          operator: operator,
          values: values,
          uid: uid
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectElement", function (uid) {
      var selectedElement = _this.state.selectedElement;
      if (uid === selectedElement) return;
      _this.setState({
        selectedElement: uid
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onDuplicateGroup", function (pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
      var clonedGroup = R.clone(parentGroup.element.eligibilityRows[parentGroup.position]);
      parentGroup.element.eligibilityRows.splice(parentGroup.position + 1, 0, (0, _helpers.addUidsToRules)(clonedGroup));
      _this.props.onChange(newRules);
    });
    _defineProperty(_assertThisInitialized(_this), "onDuplicateRule", function (pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
      var clonedRule = R.clone(parentGroup.element.eligibilityRows[parentGroup.position]);
      clonedRule.uid = (0, _uuid.v4)();
      parentGroup.element.eligibilityRows.splice(parentGroup.position + 1, 0, clonedRule);
      _this.props.onChange(newRules);
    });
    _defineProperty(_assertThisInitialized(_this), "onDeleteElement", function (type, pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var pathKeysCopy = R.clone(pathKeys);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeysCopy);
      parentGroup.element.eligibilityRows.splice(parentGroup.position, 1);

      // MIO this really needs to be abstracted away and properly unit tested.
      // if after deleting the element the resulting group has only one item remaining
      if (parentGroup.element.eligibilityRows.length === 1 && pathKeys.length > 0) {
        var remainingElement = parentGroup.element.eligibilityRows.pop();
        // if the parent group is the root group we should allow it to have one element */
        if (newRules === parentGroup.element) {
          // if remaining element is a group it should replace the parent group
          if (remainingElement.eligibilityRowsOperator) {
            Object.assign(parentGroup.element, remainingElement);
            // if remaining element is not a group it should be placed in a group without operator
          } else {
            parentGroup.element.eligibilityRows.push(remainingElement);
            delete parentGroup.element.eligibilityRowsOperator;
          }
        } else {
          Object.assign(parentGroup.element, remainingElement);

          /* if the remaining element is not a group then we should transform the parent group into a
            simple rule
          */
          if (remainingElement.eligibilityRows === undefined) {
            delete parentGroup.element.eligibilityRows;
            delete parentGroup.element.eligibilityRowsOperator;
          } else {
            Object.assign(parentGroup.element, remainingElement);
            pathKeys.shift();
            pathKeys.pop();
            var grandParentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
            R.path(['element', 'eligibilityRows'], grandParentGroup).forEach(function (element, index) {
              if (grandParentGroup.element.eligibilityRowsOperator === R.prop('eligibilityRowsOperator', element)) {
                var _R$path;
                (_R$path = R.path(['element', 'eligibilityRows'], grandParentGroup)).splice.apply(_R$path, [index, 1].concat(_toConsumableArray(element.eligibilityRows)));
              }
            });
          }
        }
      } else if (parentGroup.element.eligibilityRows.length === 0 || pathKeys.length === 0) {
        newRules = {};
      }
      _this.props.onChange(newRules);
    });
    _defineProperty(_assertThisInitialized(_this), "onAddNewRule", function (type, pathKeys) {
      var newRules = R.clone(_this.props.rules);
      var emptyRule = R.clone(_helpers.emptySimpleRule);
      var parentGroup = _this.getRuleObjectToChange(newRules, pathKeys);
      if (!parentGroup.element.eligibilityRowsOperator || parentGroup.element.eligibilityRowsOperator === type) {
        parentGroup.element.eligibilityRows.splice(parentGroup.position + 1, 0, _objectSpread(_objectSpread({}, emptyRule), {}, {
          uid: (0, _uuid.v4)()
        }));
        parentGroup.element.eligibilityRowsOperator = type;
      } else {
        parentGroup.element.eligibilityRows[parentGroup.position] = {
          eligibilityRowsOperator: type,
          eligibilityRows: [parentGroup.element.eligibilityRows[parentGroup.position], _objectSpread(_objectSpread({}, emptyRule), {}, {
            uid: (0, _uuid.v4)()
          })],
          uid: (0, _uuid.v4)()
        };
      }
      _this.props.onChange(newRules);
    });
    _defineProperty(_assertThisInitialized(_this), "getRuleObjectToChange", function (element, pathKeys) {
      var parentDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var position = pathKeys.shift();
      if (pathKeys.length >= parentDepth) {
        return _this.getRuleObjectToChange(element.eligibilityRows[position], pathKeys);
      }
      return {
        element: element,
        position: position
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderSimpleRule", function (id, rule) {
      var pathKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var parentOperator = arguments.length > 3 ? arguments[3] : undefined;
      var labels = arguments.length > 4 ? arguments[4] : undefined;
      var hideMenu = arguments.length > 5 ? arguments[5] : undefined;
      var _this$props = _this.props,
        variableOptions = _this$props.variableOptions,
        operatorOptions = _this$props.operatorOptions,
        onLookupData = _this$props.onLookupData,
        lookUpValues = _this$props.lookUpValues,
        errors = _this$props.errors,
        searchableAction = _this$props.searchableAction,
        type = _this$props.type;
      var isLinkedRewardsEligibility = _this.state.isLinkedRewardsEligibility;
      var computedId = "".concat(id).concat(pathKeys.join('-'));
      if (R.isEmpty(variableOptions || R.isEmpty(operatorOptions) || R.isEmpty(lookUpValues))) {
        return /*#__PURE__*/_react["default"].createElement(_loader.PageLoader, {
          key: (0, _uuid.v4)(),
          pastDelay: true
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_SimpleRule["default"], {
        disabled: R.prop('disabled', _this.props),
        className: "simple-rule",
        key: rule.uid || id,
        pathKeys: pathKeys,
        id: computedId,
        onClick: function onClick(e) {
          e.stopPropagation();
          _this.onSelectElement(rule.uid);
        },
        onRuleChange: _this.onRuleChange,
        onDuplicate: _this.onDuplicateRule,
        onDelete: _this.onDeleteElement,
        onAddNew: _this.onAddNewRule,
        operatorOptions: operatorOptions,
        rule: rule,
        parentOperator: parentOperator,
        isSelected: rule.uid === _this.state.selectedElement,
        variableOptions: variableOptions,
        lookUpValues: lookUpValues,
        onLookupData: onLookupData,
        isDuplicateDisabled: parentOperator === 'IF',
        labels: _objectSpread(_objectSpread({}, labels), {}, {
          LEFT_OPERAND_PLACEHOLDER: isLinkedRewardsEligibility ? labels.LINKED_REWARDS_VARIABLE_PLACEHOLDER : labels.ELIGIBILITY_VARIABLE_PLACEHOLDER
        }),
        errors: R.path([type, rule.uid], errors),
        hideMenu: hideMenu,
        searchableAction: searchableAction,
        hasDisjunction: !isLinkedRewardsEligibility
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderRuleGroup", function (_ref2) {
      var id = _ref2.id,
        uid = _ref2.uid,
        operator = _ref2.operator,
        rules = _ref2.rules,
        _ref2$pathKeys = _ref2.pathKeys,
        pathKeys = _ref2$pathKeys === void 0 ? [] : _ref2$pathKeys,
        labels = _ref2.labels;
      var computedId = "".concat(id).concat(pathKeys.join('-'));
      var isFirstGroup = pathKeys.length === 0;
      var disableFirstGroupDelete = _this.props.disableFirstGroupDelete;
      var groupProps = {
        groupOperator: operator || 'IF'
      };
      if (groupProps.groupOperator === 'IF') {
        groupProps.isMenuHidden = true;
        groupProps.className = 'if-group';
        groupProps.onClick = function (e) {
          e.stopPropagation();
          _this.onSelectElement(rules[0].uid);
        };
        groupProps.isSelected = rules[0].uid === _this.state.selectedElement;
      }
      if (isFirstGroup && disableFirstGroupDelete) {
        groupProps.isMenuHidden = true;
      }
      return /*#__PURE__*/_react["default"].createElement(_RuleGroup["default"], _extends({
        disabled: R.prop('disabled', _this.props),
        key: uid,
        uid: uid,
        id: computedId,
        onClick: function onClick(e) {
          e.stopPropagation();
          _this.onSelectElement(uid);
        },
        onDuplicate: _this.onDuplicateGroup,
        onDelete: _this.onDeleteElement,
        isDuplicateDisabled: isFirstGroup,
        isSelected: uid === _this.state.selectedElement,
        pathKeys: pathKeys,
        labels: labels
      }, groupProps), rules.map(function (rule, key) {
        if (rule.eligibilityRows) {
          return _this.renderRuleGroup({
            id: id,
            uid: rule.uid,
            operator: rule.eligibilityRowsOperator,
            rules: rule.eligibilityRows,
            pathKeys: [].concat(_toConsumableArray(pathKeys), [key]),
            labels: labels
          });
        }
        return _this.renderSimpleRule("".concat(id), rule, [].concat(_toConsumableArray(pathKeys), [key]), groupProps.groupOperator, labels, isFirstGroup && disableFirstGroupDelete);
      }));
    });
    var _isLinkedRewardsEligibility = props.type === 'additionalRewardsEligibility';
    _this.state = {
      selectedElement: '',
      isLinkedRewardsEligibility: _isLinkedRewardsEligibility
    };
    return _this;
  }
  _createClass(RulesBuilder, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        id = _this$props2.id,
        labels = _this$props2.labels,
        rules = _this$props2.rules;
      return rules && this.renderRuleGroup({
        id: id,
        uid: rules.uid,
        operator: rules.eligibilityRowsOperator,
        rules: rules.eligibilityRows,
        pathKeys: [],
        labels: labels
      });
    }
  }]);
  return RulesBuilder;
}(_react["default"].Component);
RulesBuilder.propTypes = {
  searchableAction: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  variableOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  operatorOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  lookUpValues: _propTypes["default"].shape({}),
  onLookupData: _propTypes["default"].func,
  onChange: _propTypes["default"].func.isRequired,
  rules: _propTypes["default"].shape({
    uid: _propTypes["default"].string,
    eligibilityRowsOperator: _propTypes["default"].string,
    eligibilityRows: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  /** A list of error objects for all the simple rules */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].shape({})]),
  /** CMS labels */
  labels: _propTypes["default"].shape({}),
  disableFirstGroupDelete: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(['additionalRewardsEligibility', 'eligibility'])
};
RulesBuilder.defaultProps = {
  disabled: false,
  lookUpValues: null,
  searchableAction: function searchableAction() {
    return Promise.resolve({});
  },
  onLookupData: function onLookupData() {},
  errors: {},
  labels: {},
  disableFirstGroupDelete: false,
  type: 'eligibility'
};
RulesBuilder.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onRuleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ variable, operator, values, uid }",
      "type": null
    }, {
      "name": "pathKeys",
      "type": null
    }, {
      "name": "variableOperands",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onSelectElement",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "uid",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDuplicateGroup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "pathKeys",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDuplicateRule",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "pathKeys",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDeleteElement",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "type",
      "type": null
    }, {
      "name": "pathKeys",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onAddNewRule",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "type",
      "type": null
    }, {
      "name": "pathKeys",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getRuleObjectToChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "element",
      "type": null
    }, {
      "name": "pathKeys",
      "type": null
    }, {
      "name": "parentDepth",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderSimpleRule",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "id",
      "type": null
    }, {
      "name": "rule",
      "type": null
    }, {
      "name": "pathKeys",
      "type": null
    }, {
      "name": "parentOperator",
      "type": null
    }, {
      "name": "labels",
      "type": null
    }, {
      "name": "hideMenu",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderRuleGroup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ id, uid, operator, rules, pathKeys = [], labels }",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "RulesBuilder",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "lookUpValues": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "searchableAction": {
      "defaultValue": {
        "value": "() => Promise.resolve({})",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onLookupData": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "A list of error objects for all the simple rules",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }, {
          "name": "shape",
          "value": {}
        }]
      },
      "required": false
    },
    "labels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "CMS labels",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "disableFirstGroupDelete": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'eligibility'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'additionalRewardsEligibility'",
          "computed": false
        }, {
          "value": "'eligibility'",
          "computed": false
        }]
      },
      "required": false
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "variableOptions": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    },
    "operatorOptions": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "rules": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "uid": {
            "name": "string",
            "required": false
          },
          "eligibilityRowsOperator": {
            "name": "string",
            "required": false
          },
          "eligibilityRows": {
            "name": "arrayOf",
            "value": {
              "name": "shape",
              "value": {}
            },
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = (0, _reactClickOutside["default"])(RulesBuilder);
exports["default"] = _default;